/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import RateReviewOutlinedIcon from '@material-ui/icons/RateReviewOutlined';

export default function ShowSentiment(props)
{
    const [showSentiment, setShowSentiment] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setShowSentiment(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleShowSentiment = () => {
        setShowSentiment(!showSentiment);
        props.onChange(!showSentiment)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={showSentiment}
                        onChange={handleShowSentiment}
                        name="Show Sentiment"
                        color="primary"
                        />
                    }
                    label="Show Sentiment"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Show the Sentiment widget">
                        <RateReviewOutlinedIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

